export default {
  methods: {
    paymentTracking: (id, value) => {
      if (MEConfig.get('app.env') !== 'production') {
        return;
      }

      try {
        gtag('event', 'conversion', {
          'send_to': 'AW-944661966/PQjTCNnkj5YBEM7LucID',
          'value': value,
          'currency': 'BRL',
          'transaction_id': id
        });
      } catch (e) {
        console.error(e);
      }

      try {
        fbq('track', 'Purchase', {
          value: value,
          currency: 'BRL',
          contents: [
            {
              id: id,
              quantity: 1,
              item_price: value
            }
          ],
          content_type: 'product'
        });
      } catch (e) {
        console.error(e);
      }

      try {
        gtag('event', 'purchase', {
          'value': value,
          'currency': 'BRL',
          'transaction_id': id
        });
      } catch (e) {
        console.error(e);
      }
    }
  }
};
